import styled from 'styled-components';

export const CheckBox = styled.input.attrs({type: 'checkbox'})(
  props => `
  height: 1.3rem;
  width: 1.3rem;
  margin-right: ${props.theme.spacing.small};
  padding-right: ${props.theme.spacing.xlarge};
  align-items: center;
  justify-content: center;
  border-radius: 0.2rem;
  display: inline-flex;
  cursor: pointer;
  &::checked {
    border: 0.1rem solid ${props.theme.colors.goBrandBlue.base};
    background-color: ${props.theme.colors.goBrandBlue.base};
  }
`,
);
